import { Component, OnInit, Injector, Input, Output, SimpleChange, ViewChild, OnDestroy } from '@angular/core';
import { MainComponent } from '../main-component/main.component';
import { ActivatedRoute } from '@angular/router';
import { EventEmitter } from '@angular/core';
import { FilterService } from '../../services/filter.service';
import { ModalSize } from '../../services/smart-modal.service';
import { PopupFormComponent } from '../popupform/popupform.component';
import { RolePermissionService } from '../../shared/services/role-permission.service';

@Component({
    selector: 'kx-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    standalone: false
})
export class FilterComponent extends MainComponent implements OnInit, OnDestroy {
  @Input() fields: any;
  @Input() config: any;
  @Input() persistValue: any;
  @Output() getFilter: EventEmitter<any> = new EventEmitter();
  @Output() resetFilter: EventEmitter<any> = new EventEmitter();
  @Output() getData: EventEmitter<any> = new EventEmitter();
  @Output() getFilterWithBtn: EventEmitter<any> = new EventEmitter();
  @Output() resetQuickFilter: EventEmitter<any> = new EventEmitter();
  @ViewChild('form') form: any;
  // configForm: any;
  decorator: any;
  filterData: any;
  fiterConfig: any;
  filterVal: any;
  stopChangeProp: boolean = false;

  isUserGroupTooltipOpen: boolean = false;
  isSaveTooltipOpen: boolean = false;

  constructor(
    public injector: Injector,
    public route: ActivatedRoute,
    public filterService: FilterService,
    public rolePermissionService: RolePermissionService
  ) {
    super(injector, route);
  }

  ngOnInit() {
    this.fiterConfig = {
      "submitButton": true,
      "filterForm": true,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": '',
      "default_filter": this.fields && this.fields.default_filter ? this.fields.default_filter : false
    }

    if (this.persistValue && this.persistValue.filter && this.persistValue.filter != undefined && this.persistValue.filter != '') {
      try {
        var jsonString = '{';
        var items = this.persistValue.filter.split(',');
        for (let i = 0; i < items.length; i++) {
          var current = items[i].split(':');
          jsonString += '"' + current[0] + '":"' + current[1] + '",';
        }
        jsonString = jsonString.substr(0, jsonString.length - 1);
        jsonString += '}';
        this.filterData = JSON.parse(jsonString);
        console.log("Filter Data Copy ", this.filterData);
      } catch (error) {

      }

    } else
      this.filterData = '';

    if (this.config != undefined && this.config.defFilters != undefined) {
      this.fiterConfig.defFilters = this.config.defFilters;
    }
    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this.fields && this.fields.decorator != undefined && !this.decorator) {
      this.decorator = this.baseService.initDecorator(this.fields.decorator, this.route, this.injector);
    }
    //console.log("fieldsfields",this.fields.hasOwnProperty('blocks'));
  }
  doSearch(event) {
    this.communicationService.setcurrentBtnValue$(event);
    this.filterVal = event != undefined && event.result != undefined ? event.result : false;
    let filter = '';
    //console.log("this.filterService.bindFilterGrid()",filter);
    if (this.config.quickFilter && this.decorator && this.decorator.setQuickFilterData) {
      filter = this.decorator.setQuickFilterData({ 'config': this.config, 'result': event.result });
    } else {
      filter = this.filterService.bindFilterGrid(event.result);
    }
    setTimeout(() => {
      this.config.quickFilter = false;
    });

    // restricting 'Apply' Filter, without daterangefilter TO value in daterangefilter
    if (this.filterVal && this.filterVal.daterangefilter && this.filterVal.daterangefilter.FROM && !this.filterVal.daterangefilter.TO && this.form.form && this.form.form.controls && this.form.form.controls.daterangefilter) {
        this.form.form.controls.daterangefilter.status = "INVALID";
        this.form.form.controls.daterangefilter.errors = {"required": true};
        return;
    }
    this.getFilter.emit(filter);
    this.getFilterWithBtn.emit({ filter: filter, event: event });
    if (this.config.quickFilter != undefined && !this.config.quickFilter) {
        this.resetQuickFilter.emit();
    }
  }
  resetFormClick(event) {
    // to prevent api call from resetFilter method of data-grid
    if (event != undefined && event.resetQuickFilterForm != undefined && event.resetQuickFilterForm) {
        this.config.resetQuickFilterForm = true;
    }
    this.resetParams();
    this.resetFilter.emit({});
  }

  resetParams() {
    delete this.config.filterLabel;
    delete this.config.currentFilter;
    delete this.config.currentFilterName;
    this.ruleEngineService.reSetFilter(true);
  }

  async getDataFn(data: any) {

    if (data.type != undefined && data.type == "default_filter_val") { this.filterVal = data != undefined && data.obj != undefined ? data.obj : false; }


    if ((this.stopChangeProp == true && data != undefined && data.type != undefined && data.type != 'default_filter' && data.type != 'changePage') || !this.stopChangeProp) {
      if (data.type && data.type == 'default_filter') {
        if (this.decorator && this.decorator.setFilterData)
          data = await this.decorator.setFilterData(data).then((data) => { return data; });
        const filter = this.filterService.bindFilterGrid(data.obj);
        this.getData.emit({ type: data.type, obj: { form: filter } });
      } else if (data.type && data.type == 'changePage') {
        this.getData.emit({ type: data.type, obj: { page: data.page } });
      }
      else {
        this.getData.emit({ type: data.type, obj: { form: data.obj } });
        this.fiterConfig[data.type] = data.obj;
      }
    }



  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.config && changes.config.currentValue && changes.config.currentValue.reset != undefined) {
      //reset form needed
      this.fiterConfig = { ...this.fiterConfig };
      this.fiterConfig.quickReset = changes.config.currentValue.quickReset;
      this.fiterConfig.reset = changes.config.currentValue.reset;
      this.fiterConfig.submit = changes.config.currentValue.submit;
    }
    if (changes.config && changes.config.currentValue && changes.config.currentValue.currentFilter != undefined) {
      //reset form needed
      this.config.quickFilter = true;
      this.config.currentFilterName = this.config.currentFilter.replace(/__/g, ' ');
      //if (this.decorator && this.decorator.setFilterData)
    } else {
      if (this.decorator && this.decorator.setQuickFilterData) {
        let filter = this.decorator.setQuickFilterData({ 'config': changes.config.previousValue });
        this.getFilter.emit(filter);
      } else {
        // this.getFilter.emit();
      }
      if (this.config) {
        delete this.config.currentFilter;
        delete this.config.currentFilterName;
      }
    }
    if (this.config == undefined) {
      this.config = {};
    }
  }
  saveFilter(isSaveAs: any = false, forUserPref: Boolean = false) {
    console.log("Filter Config ", this.fiterConfig);
    if (this.fiterConfig["form"] == undefined || this.fiterConfig["mapping"] == undefined) {
      this.alerts.error("filter can not be saved");
    } else {
      var notSavedAr = [];
      var savedAr = {};
      var found = false;
      for (let c in this.fiterConfig.mapping) {
        if (this.fiterConfig.mapping[c] != undefined && this.fiterConfig.form.controls[c] != undefined) {
          var val: any = this.fiterConfig.form.value[this.fiterConfig.mapping[c].key];
          //  if( this.fiterConfig.mapping[c].controlType == 'searchselect' && val != ''){
          //   notSavedAr.push(this.fiterConfig.mapping[c].label);
          //  }else 
          if (this.fiterConfig.mapping[c].controlType == "daterangepicker") {
            if (val != '' && val) {
              if (this.fiterConfig.mapping[c].singleDatePicker != undefined && this.fiterConfig.mapping[c].singleDatePicker) {
                //date select 
                if (this.fiterConfig.mapping[c].selected != undefined && this.fiterConfig.mapping[c].selected) {
                  //today select, (may be extend this to yeasterday, tomorrow in future)
                  savedAr[c] = { type: this.fiterConfig.mapping[c].controlType, value: this.fiterConfig.mapping[c].value }
                  found = true;
                } else {
                  //it means random date is selected, we could not save it
                  notSavedAr.push(this.fiterConfig.mapping[c].label)
                }

              } else {
                //range select
                if (this.fiterConfig.mapping[c].startKey != undefined && this.fiterConfig.mapping[c].endKey != undefined) {
                  if (this.fiterConfig.mapping[c].chosenRange && this.fiterConfig.mapping[c]['chosenRange'] != '' && this.fiterConfig.mapping[c]['chosenRange'] != undefined && this.fiterConfig.mapping[c]['chosenRange'] == 'Custom range') {
                    //it means range is selected and we could not save it
                    // notSavedAr.push(this.fiterConfig.mapping[c].label)
                    let range, originalFrom, originalTo;

                    if (val['BILLTO'] && val['BILLFROM']) {
                      originalFrom = val['BILLFROM'];
                      originalTo = val['BILLTO'];
                      range = Math.ceil((val['BILLTO'] - val['BILLFROM']) / (1000 * 3600 * 24));
                    } else {
                      originalFrom = val['FROM'];
                      originalTo = val['TO'];
                      range = Math.ceil((val['TO'] - val['FROM']) / (1000 * 3600 * 24));
                    }
                    if (range === 0) range = 1;
                    savedAr[c] = { type: this.fiterConfig.mapping[c].controlType, value: range, custom: true, originalFrom: originalFrom, originalTo: originalTo };
                    found = true;


                  } else if (val && val[this.fiterConfig.mapping[c].startKey] != undefined && val[this.fiterConfig.mapping[c].endKey] != undefined && (val[this.fiterConfig.mapping[c].startKey] != null || val[this.fiterConfig.mapping[c].endKey] != null) && this.fiterConfig.mapping[c]['chosenRange'] != '' && this.fiterConfig.mapping[c]['chosenRange'] != undefined) {
                    savedAr[c] = { type: this.fiterConfig.mapping[c].controlType, value: this.fiterConfig.mapping[c]['chosenRange'] };
                    found = true;
                    // this.getData.emit({ type:'filter_save',obj:{key:val['chosenRange'],data:savedAr,name:val['chosenRange']}});              
                  }
                }
              }
            }
          } else {
            if (this.fiterConfig.form.controls[c].value != "") {
              savedAr[c] = { type: this.fiterConfig.mapping[c].controlType, value: this.fiterConfig.form.controls[c].value };
              if (this.fiterConfig.mapping[c].controlType != "hidden") {
                found = true;
              }
            }
          }
        }
      }
      //check if any value is being neglected if show notice and ask for permission
      if (notSavedAr.length) {
        var allPromiseObj = [];
        for (let index = 0; index < notSavedAr.length; index++) {
          allPromiseObj.push(this.baseService.asyncLanguageProcess(notSavedAr[index]));
        }
        Promise.all(allPromiseObj).then((promiseResponse) => {
          var dialogRef = this.modalService.confirm("Warning!", "Some filters: [" + promiseResponse.join(', ') + "] can not be saved, continue with the rest?", ModalSize.Sm);
          dialogRef.subscribe(result => {
            if (result) {
              if (!found) {
                this.alerts.error("field.label.Please_select_some_filter_to_save");
                return;
              }
              setTimeout(() => {
                this.askForName(isSaveAs, savedAr);
              });
            }
          });
        });
      } else {
        if (!found) {
          this.alerts.error("field.label.Please_select_some_filter_to_save");
          return;
        }
        this.askForName(isSaveAs, savedAr, forUserPref);
      }
    }
  }

  askForName(isSaveAs, savedAr, forUserPref?) {
    //if currentfilter is defined it means its save not saveas
    if (this.config.currentFilter != undefined && !isSaveAs) {
      this.getData.emit({ type: 'filter_save', obj: { key: this.config.currentFilter, data: savedAr, name: this.config.currentFilterName } });
    }
    else if (forUserPref) {
      this.saveUserGroupFilters(isSaveAs, savedAr, forUserPref);
    }
    else {
      var filterName = prompt("Please enter filter name", "");
      if (filterName != null && filterName != "") {
        var regex = /^[a-zA-Z0-9 ]*$/;
        if (regex.test(filterName)) {
          if (filterName.length > 25) {
            this.alerts.error("Maximum 25 characters are allowed.");
          } else {
            let filterKey = filterName.replace(/ /g, '');
            if (this.persistValue && this.persistValue.saveKey && this.persistValue.saveKey != undefined)
              this.preferenceService.getUserPreferenceConfig(this.persistValue.saveKey, (data) => {
                console.log("data is ", data);
                if (data && data["filter__"] != undefined && data["filter__"].length > 0) {
                  let name_search = data["filter__"].find(val => {
                    return val.name.toLowerCase() == filterKey.toLowerCase();
                  });
                  if (name_search != undefined) {
                    this.alerts.error("Filter already exist with same name");
                  } else {
                    this.getData.emit({ type: 'filter_save', obj: { key: filterKey, data: savedAr, name: filterName } });
                  }
                } else {
                  this.getData.emit({ type: 'filter_save', obj: { key: filterKey, data: savedAr, name: filterName } });
                }
              });
          }
        } else {
          this.alerts.error("Special characters not allowed.");
        }
      }
    }
  }


  saveUserGroupFilters(isSaveAs, savedAr, forUserPref) {
    let obj = {
      resource: "userGroupFilter",
      action: "ADD",
      layout_type: "simple",
      getdata: true
    };
    this.smartModalService.open(PopupFormComponent, obj, "Create UserGroup Filters", ModalSize.Md).subscribe(res => {
      if (res) {
        if (this.persistValue && this.persistValue.saveKey && this.persistValue.saveKey != undefined) {
          this.preferenceService.getUserPreferenceConfig("account__" + this.persistValue.saveKey, (data) => {
            let filterKey = res.result.result.name.replace(/ /g, '');
            console.log("data is ", data);
            if (data && data["filter__"] != undefined && data["filter__"].length > 0) {
              let name_search = data["filter__"].find(val => {
                return val.name.toLowerCase() == filterKey.toLowerCase();
              });
              if (name_search != undefined) {
                this.alerts.error("Filter already exist with same name");
              } else {
                this.getData.emit({ type: 'filter_save', obj: { key: res.result.result.name, data: savedAr, name: res.result.result.name, userGroupId: res.result.result.userGroup, isRule: res.result.result.stopRule, facility_id: this.appService.getOrganization().org_id }, forUserPref: forUserPref });
              }
            } else {
              this.getData.emit({ type: 'filter_save', obj: { key: res.result.result.name, data: savedAr, name: res.result.result.name, userGroupId: res.result.result.userGroup, isRule: res.result.result.stopRule, facility_id: this.appService.getOrganization().org_id }, forUserPref: forUserPref });
            }
          });


        }

      }
    }, err => {

    })
  }
  ngOnDestroy() {
    console.log("FilterComponent destroyed");
  }
}
